import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, Phone, Shield, Clock, Award } from 'lucide-react';

const stats = [
  { icon: Clock, value: '10+', label: 'Ans d\'expérience' },
  { icon: Shield, value: '100%', label: 'Véhicules révisés' },
  { icon: Award, value: '4.9/5', label: 'Avis clients' },
];

export default function HeroSection() {
  return (
    <section
      className="hero-section relative flex items-center"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1610809589386-9ea41901eb54?auto=format&fit=crop&w=1920&q=80')`,
      }}
      data-testid="hero-section"
    >
      <div className="absolute inset-0 hero-overlay"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-24 lg:py-32 w-full">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block mono text-[#DC2626] text-xs tracking-[0.2em] uppercase mb-6" data-testid="hero-label">
              Garage Automobile — Quarouble (59)
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold text-white mb-6 tracking-tight leading-[1.05]" style={{ fontFamily: 'var(--font-heading)' }}>
              Votre garage<br />
              <span className="text-[#DC2626]">de confiance</span><br />
              à Quarouble
            </h1>

            <p className="text-base sm:text-lg text-zinc-400 mb-10 leading-relaxed max-w-xl">
              Réparation, diagnostic, vente de véhicules d'occasion contrôlés.
              Des professionnels passionnés à votre service depuis plus de 10 ans.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-3 mb-16"
          >
            <Link
              to="/vehicules"
              className="group inline-flex items-center justify-center gap-2 px-7 py-4 bg-[#DC2626] text-white font-semibold text-sm tracking-wide transition-all duration-200 hover:bg-[#B91C1C] hover:shadow-lg hover:shadow-red-600/30"
              data-testid="hero-vehicules-btn"
            >
              Voir les véhicules
              <ChevronRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-7 py-4 border border-white/20 text-white font-semibold text-sm tracking-wide transition-all duration-200 hover:bg-white/5 hover:border-white/40"
              data-testid="hero-devis-btn"
            >
              Demander un devis
            </Link>
            <a
              href="tel:+33613851946"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 border border-white/20 text-white font-semibold text-sm tracking-wide transition-all duration-200 hover:bg-white/5 hover:border-white/40"
              data-testid="hero-appeler-btn"
            >
              <Phone size={16} /> 06 13 85 19 46
            </a>
          </motion.div>

          {/* Trust Stats */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-wrap gap-6 lg:gap-12"
          >
            {stats.map((stat, i) => (
              <div key={i} className="flex items-center gap-3" data-testid={`hero-stat-${i}`}>
                <div className="w-10 h-10 flex items-center justify-center bg-white/5 border border-white/10">
                  <stat.icon size={18} className="text-[#DC2626]" />
                </div>
                <div>
                  <div className="text-white font-bold text-lg leading-none" style={{ fontFamily: 'var(--font-mono)' }}>{stat.value}</div>
                  <div className="text-zinc-500 text-xs mt-0.5">{stat.label}</div>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
